module.exports = __webpack_public_path__ + "img/bufu-logo-admin.96dcc76e.png";